<template>
  <div class="home bg-grey">
    <NavbarMain />
    <div class="container mt-5">
      <div class="form-group bg-light-2 p-4 border shadow-sm mt-5">
        <h4>
          Detalles por el cual sera cancelada la publicación "{{
            product.name
          }}" de
          <b class="text-capitalize">{{ product.sellerId.username }}</b>
        </h4>
        <hr />
        <textarea
          type="text"
          class="form-control"
          placeholder="Detalles..."
          rows="10"
          v-model="msgCancel"
        ></textarea>

        <span v-if="isLoadCancel" class="btn btn-block btn-primary my-3"
          ><span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span
        ></span>
        <span
          v-else
          class="btn btn-block btn-primary my-3"
          @click="cancelProduct"
          >Cancelar</span
        >
      </div>
    </div>
    <ModalNotify
      :visible="modalNotify.visible"
      :success="modalNotify.success"
      :title="modalNotify.title"
      :body="modalNotify.body"
      :acept="modalNotify.acept"
      :return="modalNotify.return"
      v-on:click="handleClickModal"
      v-on:clickReturn="handleCloseModal"
    />
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import ModalNotify from "../../components/modals/ModalNotify";
import Api from "../../tools/Api2";
import { mapState } from "vuex";
import Configs from "@/configs/configs";

export default {
  name: "AdminCancelProduct",
  data() {
    return {
      modalNotify: {
        visible: false,
        success: false,
        title: "Ups, algo salio mal!",
        body: "hubo un problema al cancelar el producto",
        return: false,
        redirect: "/admin/products",
        acept: false,
      },
      isLoadCancel: false,
      msgCancel: "",
      product: {
        name: "",
        sellerId: {
          username: "",
        },
      },
      url: Configs.API.BASE,
    };
  },
  components: {
    NavbarMain,
    ModalNotify,
  },
  methods: {
    handleCloseModal(){
      this.modalNotify.visible = false;
    },
    handleClickModal() {
      this.$router.push("/admin/products");
    },
    cancelProduct() {
      this.isLoadCancel = true;
      Api("product")
        .patch(this.$route.params.id, {
          state: 2,
          msgCancel: this.msgCancel,
        })
        .then((res) => {
          if (!res.error) {
            this.modalNotify.title = "Producto actualizado!";
            this.modalNotify.body = "la publicacion ha sido actualizada con exito";
            this.modalNotify.return = false;
            this.modalNotify.acept = true;
          } else {
            this.modalNotify.title = "Ups, algo salio mal!";
            this.modalNotify.body = `hubo un problema al cancelar el producto. ${res.error}`;
            this.modalNotify.return = true;
            this.modalNotify.acept = false;
          }
          this.modalNotify.visible = true;
          this.modalNotify.success = !res.error;
          this.isLoadCancel = false;
        });
    },
  },
  created: async function () {
    window.scrollTo(0, 0);
    Api("product")
      .get(this.$route.params.id)
      .then((res) => {
        this.product = res.product;
      });
  },
  computed: {
    ...mapState(["auth"]),
  },
};
</script>

<style scoped>
#amount-input {
  width: 4em;
  display: inline;
}

/* number inputs with arrows always visible */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 1;
}

.old-price {
  text-decoration: line-through;
  font-size: 0.8em;
}

.old-price div {
  margin-left: 0.5em;
  text-decoration: line-through;
  text-decoration-color: grey;
  font-size: 0.8em;
}
</style>